module.exports = __webpack_public_path__ + "static/media/11.Falicitation.5f3652fd.jpg";